<template>
    <div class="invite">
        <div class="invite-top">
            <!-- <div :style="[baseStyles]"></div>
            <van-nav-bar
                title=""
                left-arrow
                class="invite-bar"
                @nav-bar-icon-color="'#000'"
            ></van-nav-bar> -->
            <div class="invite-info">
                <div class="info-title">
                    <span class="title-color">仅需</span>
                    <span class="title-num">2</span>
                    <span class="title-color">步入驻吉祥有约！</span>
                </div>
                <div class="invite-tips">在吉祥有约，拓客流，增业绩</div>
                <div class="invite-step">
                    <div class="invite-step-count">
                        <div class="step-count-num">1</div>
                        <div class="step-count-text">分享开店链接给美容院店家</div>
                    </div>
                    <div class="step-count-and">|</div>
                    <div class="invite-step-count">
                        <div class="step-count-num">2</div>
                        <div class="step-count-text">店家通过链接提交开店信息即可免费入驻</div>
                    </div>
                </div>
                <div class="invite-tips">（获得美容院专属营销商城与店务管理系统一套）</div>
                <div class="invite-share">
                    <img class="share-img" src="@/assets/open_icon.png" alt="分享图片">
                    <span class="share-desc">成功招商邀请门店入驻，躺赚收益</span>
                </div>
                <div class="store-p">
                    <div class="store-info">
                        <div class="store-title">请选择门店所属信息</div>
                        <div class="store-int">
                            <div class="store-int-label">所属厂家</div>
                            <van-field
                                v-model="factoryBrandName"
                                placeholder="请选择所属厂家"
                                input-align="right"
                                error-message-align="right"
                                :right-icon="isChangeBrandFactory ? 'arrow-down' : ''"
                                label-class="store-field-label"
                                style="width: 240px;"
                                readonly
                                @click="showStoreFactory = isChangeBrandFactory"
                            />
                        </div>
                        <div class="store-int">
                            <van-field
                                v-model="agentName"
                                label-class="store-field-label"
                                label="所属服务商"
                                placeholder="请选择所属服务商名称"
                                input-align="right"
                                error-message-align="right"
                                :right-icon="isChangeAgent ? 'arrow-down' : ''"
                                readonly
                                @click="showModal = isChangeAgent"
                            />
                        </div>
                        <div class="store-int">
                            <van-field
                                v-model="chainName"
                                label-class="store-field-label"
                                label="所属连锁"
                                placeholder="请选择所属连锁"
                                input-align="right"
                                error-message-align="right"
                                :right-icon="isChangeChain ? 'arrow-down' : ''"
                                readonly
                                @click="showChainPopup = isChangeChain"
                            />
                        </div>
                        <div class="store-int">
                            <div class="store-int-label">所属品牌</div>
                            <van-field
                                v-model="brandName"
                                placeholder="请选择所属品牌"
                                input-align="right"
                                error-message-align="right"
                                style="width: 240px;"
                                readonly
                                right-icon="arrow-down"
                                @click="showBrand = true"
                            />
                        </div>
                        <div class="store-int">
                            <van-field
                                v-model="storeKind"
                                right-icon="arrow-down"
                                input-align="right"
                                readonly
                                label-class="store-field-label"
                                label="门店类型"
                                placeholder="请选择门店类型"
                                @click="showPopup = true"
                            />
                        </div>
                        <div class="store-int">
                            <div class="store-int-label">系统版本</div>
                            <van-field
                                v-model="storeVip"
                                right-icon="arrow-down"
                                input-align="right"
                                readonly
                                style="width: 240px;"
                                label-class="store-field-label"
                                placeholder="请选择系统版本"
                                @click="showPicker = true"
                            />
                        </div>
                        <div class="store-btn">
                            <van-button type="primary" @click="generateUrl">分享开店链接</van-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="agent-list">
            <div class="agent-list-title">邀请记录</div>
            <van-empty v-if="isEmpty" description="暂无数据" />
            <!-- <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh" > -->
            <van-list
                v-model:loading="loading"
                :finished="finished"
                :finished-text="finishedText"
                @load="onLoad"
            >
                <div class="agent-list-body" v-for="item in list" :key="item" :title="item">
                    <div class="agent-list-body-l">
                        <div class="img-body">
                            <img class="body-l-img" :src="item.coverImage" alt="服务商头像">
                        </div>
                        <div class="info-body">
                            <div class="info-body-name">{{item.name}}</div>
                            <div class="info-body-phone">{{item.phone}}</div>
                        </div>
                    </div>
                    <div class="agent-list-body-r">已入驻</div>
                </div>
            </van-list>
            <!-- </van-pull-refresh> -->
        </div>
        <!-- 连锁店 -->
        <van-action-sheet
           v-model:show="showChainPopup"
           :closeable="false"
           @click-overlay="onCloseActionSheet"
           title="所属连锁">
            <div class="sheet-list">
                <div class="sheet-list-input">
                    <van-search
                        v-model="keyword"
                        placeholder="输入搜索关键词"
                        @blur="onSearch"
                        @search="onSearch"
                        @clear="onSearch"
                    />
                </div>
                <div class="sheet-list-body" v-if="storeChainList.length > 0">
                    <div :class="item.id == curChainId ? 'sheet-list-body-text active-color' : 'sheet-list-body-text'"
                        @click="onChooseChain(item)"
                        v-for="item in storeChainList"
                        :key="item.id"
                        :name="item.id">{{item.name}}</div>
                </div>
                <div class="error-tips" v-else>该工厂/服务商下没有连锁数据！</div>
                <div class="sheet-list-btn">
                    <van-button type="success" @click="onChainClose">取消</van-button>
                    <van-button type="warning" @click="onConfirmChain">确认</van-button>
                </div>
            </div>
        </van-action-sheet>
        <!-- 服务商 -->
        <van-action-sheet
           v-model:show="showModal"
           :closeable="false"
           @click-overlay="closeActionSheet"
           title="服务商">
            <div class="sheet-list">
                <div class="sheet-list-input">
                    <van-search
                        v-model="search"
                        placeholder="输入姓名搜索"
                        @blur="searchFun"
                        @search="searchFun"
                        @clear="searchFun"
                    />
                </div>
                <div class="sheet-list-body" v-if="agentList.length > 0">
                    <div :class="item.id == curAgentId ? 'sheet-list-body-text active-color' : 'sheet-list-body-text'"
                        @click="getAgentt(item)"
                        v-for="item in agentList"
                        :key="item.id"
                        :name="item.id">{{item.name}}</div>
                    <!-- <van-radio-group v-model="agentId">
                        <van-radio  v-for="item in agentList" :key="item.id" :name="item.id">{{item.name}}</van-radio>
                    </van-radio-group> -->
                </div>
                <div class="error-tips" v-else>该工厂下没有服务商数据！</div>
                <div class="sheet-list-btn">
                    <van-button type="success" @click="onClose">取消</van-button>
                    <van-button type="warning" @click="chooseAgent">确认</van-button>
                </div>
            </div>
        </van-action-sheet>
        <van-action-sheet
            v-model:show="showBrand"
            :actions="actions"
            @select="onSelect"
            cancel-text="取消"
            close-on-click-action
        />

        <van-action-sheet
            v-model:show="showShare"
            title="分享至"
        >
            <div class="share-counts">
                <div class="counts-list">
                    <div class="counts-list-body" @click="shareFun">
                        <img class="counts-list-body-img" src="@/assets/share/weixin.png" alt="">
                        <div class="counts-list-body-text">微信好友</div>
                    </div>
                    <div class="counts-list-body" @click="shareFun">
                        <img class="counts-list-body-img" src="@/assets/share/pyq.png" alt="">
                        <div class="counts-list-body-text">朋友圈</div>
                    </div>
                    <div class="counts-list-body">
                        <img class="counts-list-body-img" src="@/assets/share/down.png" alt="">
                        <div class="counts-list-body-text">分享海报</div>
                    </div>
                </div>
            </div>
        </van-action-sheet>
        <van-popup v-model:show="showPicker" position="bottom">
            <van-picker
                :columns="storeVipList"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>
        <van-popup v-model:show="showPopup" position="bottom">
            <van-picker
                :columns="kindList"
                @confirm="onKindConfirm"
                @cancel="showPopup = false"
            />
        </van-popup>
        <van-popup v-model:show="showStoreFactory" position="bottom">
            <van-picker
                :columns="factoryBrandList"
                @confirm="onFactoryConfirm"
                @cancel="showStoreFactory = false"
            />
        </van-popup>
        <!-- <van-popup v-model:show="showChainPopup" position="bottom">
            <van-picker
                :columns="storeChainList"
                @confirm="onChainConfirm"
                @cancel="showChainPopup = false"
            />
        </van-popup> -->
    </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from 'vue';
import { getAppToken } from "@/utils/getAppToken";
import { getShare } from "@/utils/getShare.js"
export default {
    name: 'InvitePage',
    setup() {
        const { proxy } = getCurrentInstance();
        const agentName = ref('')
        const brandName = ref('')
        const chainName = ref('')
        const factoryBrandName = ref('')
        const list = ref([]);
        const loading = ref(false);
        const finished = ref(false);
        const refreshing = ref(false);
        const page = ref(1)
        const size = ref(10)
        const showModal = ref(false)
        const search = ref('')
        const agentId = ref(0)
        const isEmpty = ref(false)
        const agentPage = ref(1)
        const agentSize = ref(1000000)
        const agentList = ref([])
        const brandId = ref(0)
        const shareLink = ref('')
        const finishedText = ref('暂无数据')
        const actions = ref([])
        const showBrand = ref(false)
        const showShare = ref(false)
        const config = ref({})
        const storeVipList = ref([])
        const kindList = ref([])
        const factoryBrandList = ref([])
        const storeChainList = ref([])
        const showPicker = ref(false)
        const showPopup = ref(false)
        const showStoreFactory = ref(false)
        const showChainPopup = ref(false)
        const isChangeAgent = ref(false)
        const isChangeChain = ref(false)
        const isChangeBrandFactory = ref(false)
        const storeVip = ref('')
        const storeKind = ref('')
        const keyword = ref('')
        const selectChainId = ref(0)
        let isChoose = false
        let kind = 0
        let vip = 0
        let brandFactoryId = 0
        let curAgentId = ref(0)
        let curAgentName = ref('')
        let curChainId = ref(0)
        let curChainName = ref('')
        const customFieldName = {
            text: 'name',
            value: 'type',
            children: 'children',
        }
        const token = ref('')
        const imgUrl = ref('@/assets/share/share.jpg')
        // const token = ref('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDM3NDcwODEsImp4dF9BZ2VudElkIjoxMDAyNjMsImp4dF9BZ2VudE5hbWUiOiLpnZLnp4DljLrku6PnkIYiLCJqeHRfQ2hhaW5JZCI6MCwianh0X0NoYWluTmFtZSI6IiIsImp4dF9Hcm91cElkIjoxLCJqeHRfR3JvdXBOYW1lIjoi5ZCJ56Wl5aSpIiwianh0X0xvZ2luS2V5IjoiMTU5ODY3Mzk5MDIiLCJqeHRfTG9naW5QbGF0Zm9ybSI6MCwianh0X0xvZ2luVHlwZSI6InBob25lIiwianh0X1Bob25lIjoiMTU5ODY3Mzk5MDIiLCJqeHRfU3RvcmVJZCI6MTkyNywianh0X1N0b3JlTmFtZSI6IuS4rei0uOWbvemZheW6lyIsImp4dF9Vc2VySWQiOjUwMzIsImp4dF9Vc2VyTmFtZSI6IumDreW6l-mVvyIsImp4dF9Vc2VyVHlwZSI6MjIsIm9yaWdfaWF0IjoxNjk1MTA3MDgxfQ.Smr_1z0xinET9JbDii8VWB1RNmYKeFQOrxLbA2NxaPs')
        // const token = ref('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDQ1MzM4NjIsImp4dF9BZ2VudElkIjoxMDAyNjMsImp4dF9BZ2VudE5hbWUiOiLpnZLnp4DljLrku6PnkIZvbmV0aW1lICIsImp4dF9DaGFpbklkIjowLCJqeHRfQ2hhaW5OYW1lIjoiIiwianh0X0dyb3VwSWQiOjEsImp4dF9Hcm91cE5hbWUiOiLlkInnpaXlpKkiLCJqeHRfTG9naW5LZXkiOiIxNTk4NjczOTkwMiIsImp4dF9Mb2dpblBsYXRmb3JtIjowLCJqeHRfTG9naW5UeXBlIjoicGhvbmUiLCJqeHRfUGhvbmUiOiIxNTk4NjczOTkwMiIsImp4dF9TdG9yZUlkIjowLCJqeHRfU3RvcmVOYW1lIjoiIiwianh0X1VzZXJJZCI6NTAzMCwianh0X1VzZXJOYW1lIjoi5aW9Wnp6Iiwianh0X1VzZXJUeXBlIjo0MSwib3JpZ19pYXQiOjE2OTU4OTM4NjJ9.ersBI1U_kkCeaWN1FVSUPtik4Y4wlTZmd3gWO9NH4gU')
        // const token = ref('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDUyMTQzNjMsImp4dF9BZ2VudElkIjowLCJqeHRfQWdlbnROYW1lIjoiIiwianh0X0NoYWluSWQiOjAsImp4dF9DaGFpbk5hbWUiOiIiLCJqeHRfR3JvdXBJZCI6NSwianh0X0dyb3VwTmFtZSI6Iuebiui-viIsImp4dF9Mb2dpbktleSI6IjE1OTg2NzM5OTAyIiwianh0X0xvZ2luUGxhdGZvcm0iOjAsImp4dF9Mb2dpblR5cGUiOiJwaG9uZSIsImp4dF9QaG9uZSI6IjE1OTg2NzM5OTAyIiwianh0X1N0b3JlSWQiOjAsImp4dF9TdG9yZU5hbWUiOiIiLCJqeHRfVXNlcklkIjo2OTM4LCJqeHRfVXNlck5hbWUiOiLogIHkuo4iLCJqeHRfVXNlclR5cGUiOjMxLCJvcmlnX2lhdCI6MTY5NjU3NDM2M30.UrFllcPiHbCrXOG9CXtAFMC4knvhOa2mtJXMTHvqnMk')
        // const token = ref('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDUyMjQ5MTAsImp4dF9BZ2VudElkIjowLCJqeHRfQWdlbnROYW1lIjoiIiwianh0X0NoYWluSWQiOjAsImp4dF9DaGFpbk5hbWUiOiIiLCJqeHRfR3JvdXBJZCI6MSwianh0X0dyb3VwTmFtZSI6IuWQieelpeWkqSIsImp4dF9Mb2dpbktleSI6IjE1OTg2NzM5OTAyIiwianh0X0xvZ2luUGxhdGZvcm0iOjAsImp4dF9Mb2dpblR5cGUiOiJwaG9uZSIsImp4dF9QaG9uZSI6IjE1OTg2NzM5OTAyIiwianh0X1N0b3JlSWQiOjAsImp4dF9TdG9yZU5hbWUiOiIiLCJqeHRfVXNlcklkIjo1Mjg1LCJqeHRfVXNlck5hbWUiOiLmnajplIDorrIiLCJqeHRfVXNlclR5cGUiOjEwNSwib3JpZ19pYXQiOjE2OTY1ODQ5MTB9.fz7ABNLVgk3p_Zao0Oor1pe9DVS4WoJrrHlMPN_3CDg')
        getAppToken('token').then(() => {
            token.value = localStorage.getItem('appToken')
            let u = navigator.userAgent
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            getDefaultTemp()
            getStoreKind()
            getStoreVip()
            getFactoryBrand()
            getAgentList(1)

            if(isiOS) {
                getStoreList()
            }
        })

        const getStoreList = () => {
            if('' == token.value) return
            let time = proxy.$toast.loading('加载中...')
            proxy.$http.post(
                '/store_settled/store_list',
                { page: page.value, size: size.value },
                { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                time.close()
                if(res.success) {
                    let pageVal = page.value
                    const resList = page.value == 1 ? [] : list.value
                    const _new = res.data.list || []
                    resList.push(..._new)
                    pageVal += 1
                    page.value = pageVal
                    list.value = resList
                    loading.value = false;
                    if(res.data.list.length < size.value) {
                        finished.value = true
                    }
                    if(resList.length == 0) {
                        isEmpty.value = true
                        finishedText.value = '暂无数据'
                    } else {
                        finishedText.value = '没有更多了'
                    }
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const getFactoryBrand = () => {
            proxy.$http.post('/store_settled/brand_factory', {}, {
                headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' }
            }).then(res => {
                if (res?.data?.success) {
                    if (res.data?.data) {
                        let list = []
                        let data = res.data.data.list || []
                        data.forEach((item) => {
                            list.push({
                                text: item.name,
                                value: item.id,
                                coverImage: item.coverImage
                            })
                        })

                        factoryBrandList.value = list
                    } else {
                        proxy.$toast(res.data.errorMessage)
                    }
                }
            }).catch(err => console.log('err', err))
        }

        const getDefaultTemp = () => {
            proxy.$http.post('/store_settled/default_tmp', {}, {
                headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' }
            }).then(res => {
                if (res?.data?.success) {
                    let data = res.data?.data || {}
                    agentName.value = data.agentName
                    factoryBrandName.value = data.brandFactoryName
                    chainName.value = data.chainName
                    agentId.value = data.agentId
                    isChangeBrandFactory.value = data.isChangeBrandFactory
                    isChangeAgent.value = data.isChangeAgent
                    isChangeChain.value = data.isChangeChain
                    selectChainId.value = data.chainId
                    brandFactoryId = data.brandFactoryId

                    getStoreChain()
                    getBrand()
                } else {
                    proxy.$toast(res.data.errorMessage)
                }
            }).catch(err => console.log('err', err))
        }

        const getStoreChain = () => {
            proxy.$http.post('/store_settled/chain', {
                page: agentPage.value,
                size: agentSize.value,
                search: keyword.value,
                brandFactoryId,
                selectAgentId: agentId.value
            }, {
                headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' }
            }).then((res) => {
                if (res?.data?.success) {
                    if (res.data?.data) {
                        let data = res.data.data.list || []
                        storeChainList.value = data
                    }
                } else {
                    proxy.$toast(res.data.errorMessage)
                }
            }).catch(err => console.log('err', err))
        }

        const getStoreVip = () => {
            proxy.$http.post('/new/h5/vip/store_vip_select', {}, {
                headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' }
            }).then(res => {
                if (res?.data?.success) {
                    if (res.data?.data) {
                        let data = res.data.data || []
                        let list = []
                        data.forEach((item) => {
                            if (item.isSelect) {
                                vip = item.type
                                storeVip.value = item.name
                            }

                            list.push({
                                text: item.name,
                                value: item.type,
                                isSelect: item.isSelect
                            })
                        })

                        storeVipList.value = list
                    }
                } else {
                    proxy.$toast(res.data.errorMessage)
                }
            }).catch(err => console.log('err', err))
        }

        const getStoreKind = () => {
            proxy.$http.post('/new/h5/store/kind', {}, {
                headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' }
            }).then(res => {
                if (res?.data?.success) {
                    if (res.data?.data) {
                        let data = res.data.data || []
                        let list = []
                        data.forEach((item, index) => {
                            if (index === 0) {
                                storeKind.value = item.name
                                kind = item.kind
                            }
                            list.push({
                                text: item.name,
                                value: item.kind,
                            })
                        })

                        kindList.value = list
                    }
                } else {
                    proxy.$toast(res.data.errorMessage)
                }
            }).catch(err => console.log('err', err))
        }

        const onFactoryConfirm = (e) => {
            const { text, value } = e
            factoryBrandName.value = text
            brandFactoryId = value
            showStoreFactory.value = false
            agentName.value = ''
            chainName.value = ''
            brandName.value = ''
            agentId.value = 0
            selectChainId.value = 0
            brandId.value = 0
            getAgentList(1)
            getStoreChain()
            getBrand()
        }

        const onCloseActionSheet = () => {
            isChoose = false
        }

        const onChainClose = () => {
            isChoose = false
            showChainPopup.value = false
        }

        const onChooseChain = (item) => {
            isChoose = true
            curChainName.value = item.name
            curChainId.value = item.id
        }

        const onConfirmChain = () => {
            if (!isChoose) return
            chainName.value = curChainName.value
            selectChainId.value = curChainId.value
            showChainPopup.value = false
            brandName.value = ''
            brandId.value = 0
            getBrand()
        }

        const onSearch = () => {
            getStoreChain()
        }

        // const onChainConfirm = (e) => {
        //     const { text, value } = e
        //     chainName.value = text
        //     selectChainId.value = value
        //     showChainPopup.value = false
        //     getBrand()
        // }

        const onConfirm = (e) => {
            const { text, value } = e
            storeVip.value = text
            vip = value
            showPicker.value = false
        }

        const onKindConfirm = (e) => {
            const { text, value } = e
            storeKind.value = text
            kind = value
            showPopup.value = false
        }

        const onLoad = () => {
            if (finished.value) return

            getStoreList()
        }

        const onRefresh = () => {
            // 清空列表数据
            finished.value = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            loading.value = true;
        }

        // /store_settled/agent
        const getAgentList = (type) => {
            if(1 == type) {
                search.value = ''
            }
            proxy.$http.post(
                '/store_settled/agent',
                { page: agentPage.value, size: agentSize.value, search: search.value, brandFactoryId },
                { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    agentList.value = res.data.list
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const getAgentt = (item) => {
            isChoose = true
            curAgentId.value = item.id
            curAgentName.value = item.name
        }

        const onClose = () => {
            isChoose = false
            showModal.value = false
        }

        const closeActionSheet = () => {
            isChoose = false
        }

        const chooseAgent = () => {
            if (!isChoose) return
            agentId.value = curAgentId.value
            agentName.value = curAgentName.value
            chainName.value = ''
            brandName.value = ''
            selectChainId.value = 0
            brandId.value = 0
            showModal.value = false
            getStoreChain()
            getBrand()
        }

        ///store_settled/brand
        const getBrand = () => {
            proxy.$http.post(
                '/store_settled/brand',
                { id: agentId.value, search: search.value, brandFactoryId, selectChainId: selectChainId.value },
                { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    let list = res?.data || []
                    actions.value = list
                    if(1 == list.length) {
                        brandName.value = list[0].name
                        brandId.value = list[0].id
                    }
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const searchFun = (e) => {
            // agentList.value = []
            getAgentList(2)
        }

        const onSelect = (item) => {
            brandName.value = item.name
            brandId.value = item.id
            showBrand.value = false
        }

        const showBrandFun = () => {
            if(actions.value.length > 1 && agentId.value) {
                setTimeout(() => {
                    showBrand.value = true
                })
            }
        }

        // 分享开店链接
        const generateUrl = () => {
            if(!brandId.value) {
                proxy.$toast({
                    message: "请选择所属品牌",
                    duration: 1500,
                })

                return
            }

            let data = {
                brandFactoryId,
                chainId: selectChainId.value,
                agentId: agentId.value,
                brandId: brandId.value,
                vipLevel: vip
            }

            if (kind !== 0) {
                data['storeKind'] = kind
            }

            proxy.$http.post(
                '/store_settled/url',
                data,
                { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    setTimeout(() => {
                        config.value = res.data.jumpH5
                        shareBtn(res.data.jumpH5)
                        // showShare.value = true
                    }, 500)
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const shareBtn = (obj) => {
            getShare(obj)
        }

        const shareFun = () => {
            shareBtn(config.value)
        }
        onMounted(async () => {
            // getStoreKind()
            // getStoreVip()
            // wxConfigInit()
            // getAgentList()
        })

        return {
            list,
            loading,
            finished,
            refreshing,
            agentName,
            brandName,
            page,
            size,
            showModal,
            search,
            agentId,
            token,
            agentPage,
            agentSize,
            agentList,
            proxy,
            brandId,
            shareLink,
            actions,
            showBrand,
            showShare,
            finishedText,
            showPicker,
            customFieldName,
            storeVip,
            storeVipList,
            storeKind,
            showPopup,
            kindList,
            chainName,
            factoryBrandName,
            showChainPopup,
            showStoreFactory,
            factoryBrandList,
            storeChainList,
            isChangeAgent,
            isChangeChain,
            isChangeBrandFactory,
            keyword,
            selectChainId,
            curAgentId,
            curChainId,
            onCloseActionSheet,
            onChooseChain,
            onConfirmChain,
            onChainClose,
            onSearch,
            onClose,
            closeActionSheet,
            chooseAgent,
            onFactoryConfirm,
            onKindConfirm,
            onConfirm,
            onLoad,
            onRefresh,
            getAgentList,
            getBrand,
            onSelect,
            generateUrl,
            shareBtn,
            shareFun,
            showBrandFun,
            getAgentt,
            searchFun
        }
    },
}
</script>


<style scoped lang="scss" src="./index.scss"></style>
